<template>
  <div class="switch--with--label" :class="{'checked':checked == true, 'unchecked':checked == false}">
    <div class="switch">
      <input @change.stop="toggle" :id="id" type="checkbox" class="switch-input" :checked="checked" :disabled="disabled"/>
      <!-- <input @change="toggle" :id="id" type="checkbox" class="switch-input" :checked="checked" /> -->
      <label :for="id" class="switch-label">Switch</label>
    </div>
    <p v-if="label !=''" class="switch-label--txt" :class="{'cursor-pointer':label_clickable}"  @click="labelClicked">{{label}}</p>
  </div>
</template>

<script>
export default {
  name: "ToggleSwitch",
  data() {
    return {
    };
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: () => {
        return "toggle-" + Math.random().toString(36).substr(2, 9);
      },
    },
    label: {
      type: String,
      default: "",
    },
    checked: {
      type: Boolean,
      default: false,
    },
    label_clickable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {},
  methods: {
    toggle() {
      this.$emit("update:checked", !this.checked);
    },
    labelClicked() {
      this.$emit("label:clicked");
    }
  },
};
</script>
<style >
.switch--with--label {
  display: flex;
  align-items: center;
  /* flex-wrap: wrap; */
}

.switch {
  position: relative;
  display: inline-block;
  margin-right: 0.5rem;
}

/* Hide the checkbox input (only needed for `:checked` property) */

.switch-input {
  display: none;
}

/* Switch */

.switch-label {
  display: block;
  width: 26px;
  height: 16px;
  text-indent: -150%;
  clip: rect(0 0 0 0);
  color: transparent;
  margin-bottom: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.switch-label:before,
.switch-label:after {
  content: "";
  display: block;
  position: absolute;
  cursor: pointer;
}

.switch-label:before {
  width: 100%;
  height: 100%;
  background-color: var(--primaryDark);
  border-radius: 9999em;
  -webkit-transition: background-color 0.25s ease;
  transition: background-color 0.25s ease;
}

.switch-label:after {
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 14.5px;
  height: 14.5px;
  border-radius: 50%;
  background-color: #777777;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.45);
  -webkit-transition: all 0.25s ease;
  transition: all 0.25s ease;
}
.switch-label--txt {
  font-size: 12px;
  color: #fff;

  transition: color 0.2s ease-in-out;
}
.switch--with--label.unchecked .switch-label--txt {
  color: rgba(255, 255, 255, 0.25);
}
/* When input is checked */

/* .switch-input:checked + .switch-label {
  Switch Rail
  Switch Knob
} */

.switch-input:checked + .switch-label:before {
  background-color: var(--primaryColor);
}

.switch-input:checked + .switch-label:after {
  left: 11.5px;
  background-color: #fff;
}
</style>
